import { render, staticRenderFns } from "./PendingReviewSearchBar.vue?vue&type=template&id=1f30fedf&scoped=true&"
import script from "./PendingReviewSearchBar.vue?vue&type=script&lang=js&"
export * from "./PendingReviewSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./PendingReviewSearchBar.vue?vue&type=style&index=0&id=1f30fedf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f30fedf",
  null
  
)

export default component.exports